import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TableComponent } from '../components/table/table.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownComponent } from '../components/dropdown/dropdown.component';
import { AdminService } from '../../services/adminService';
import { DataUtils } from '../utils/DataUtils';
import { Appconstants } from '../utils/appconstants';
import { Observable, of, switchMap } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { DistrictService } from '../../services/districtService';
import { ToastModule } from 'primeng/toast';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ApiService } from '../../services/apiservice';
import { DatePickerModule } from 'primeng/datepicker';
import { DatepickerComponent } from '../components/datepicker/datepicker.component';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { MyMonitoringService } from '../../services/logging.service';

@Component({
  selector: 'app-orders-by-district-in-sap',
  standalone: true,
  imports: [DatepickerComponent, DatePickerModule, ButtonModule, ToastModule, TableComponent, DropdownComponent, ProgressSpinnerModule, FormsModule, ConfirmPopupModule],
  templateUrl: './orders-by-district-in-sap.component.html',
  styleUrl: './orders-by-district-in-sap.component.scss',
  providers: [MessageService, ConfirmationService, AdminService, DatePipe]
})

export class OrdersByDistrictInSapComponent implements OnInit {
  @ViewChild('tblConfig') tblConfig!: TableComponent;
  router: any;
  param: any;
  empId: any;
  processMessage: string = "";
  lsNorthDataColumns: any[] = [];
  actionButtons: any = [];
  isLoading: boolean = false;
  pageSize: number = 10;
  totalRecords: number = 2000;
  cellValue: any[] = ['', ''];
  selectedRow: any;
  districtOptions: SelectItem[] = [];
  insapOptions: any = [Appconstants.No, Appconstants.Yes];
  scheduledDateOptions: SelectItem[] = [];
  typeOptions: SelectItem[] = [];
  districtsMainCollection: any;
  selectedDistrict: any;
  selectedInSap: any;
  selectedScheduledDate: string = "";
  selectedType: any;
  allDistrictData: any[] = [];
  queryData: any = {};
  sortField: string = "";
  sortOrder: number = 1;
  searchText: any = "";

  filteredData$!: Observable<any[]>; //[...this.allDistrictData];
  currentPage: number = 1;

  constructor(
    private route: ActivatedRoute,
    private adminService: AdminService,
    private monotoringService: MyMonitoringService,
    private districtService: DistrictService,
    private messageService: MessageService,
    private redirectRoute: Router,
    private datePipe: DatePipe,
    private confirmationService: ConfirmationService,
    private apiService: ApiService
  ) {
    this.router = route;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.param = params.get('tier');
      this.tblConfig.searchValue = this.param;
    });

    const temp = JSON.parse(sessionStorage.getItem("queryData")!);

    this.queryData = temp;

    if (temp) {
      this.selectedDistrict = temp.data.District;
      this.selectedScheduledDate = temp.data.SchedDate;
      this.selectedType = temp.data.Type;
      this.selectedInSap = temp.data.InSap
      this.getSelectedDistrictDetails();
      sessionStorage.removeItem("queryData")
    }
    this.LoadHeader();
    this.LoadDistricts();
    //this.LoadDistrictDetails();
  }
  LoadHeader(): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.lsNorthDataColumns = [
      { "field": "District", "header": "DISTRICT", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "InSap", "header": "IN_SAP", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "SchedDate", "header": "SCHED DATE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Type", "header": "TYPE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "State", "header": "STATE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "City", "header": "CITY", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "House", "header": "HOUSE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Street", "header": "STREET", "filter": true, "isSorting": true, "width": "10%" },
      {
        "field": "Update", "header": "ACTION", "filter": false, "isSorting": false, "width": "10%", type: "action",
        isClickable: 'true', onclick: this.handleClick.bind(this)
      }
    ];
  }

  handleClick(rowData: any): void {
    this.redirectRoute.navigate(['/order-entry', rowData.CCR_ID]);

    const temp = {
      data: {
        District: this.selectedDistrict,
        InSap: this.selectedInSap,
        SchedDate: this.selectedScheduledDate,
        Type: this.selectedType
      },
      from: "/orders-by-district-in-sap"
    }
    sessionStorage.setItem("queryData", JSON.stringify(temp))
  }

  LoadDistricts(): void {
    this.isLoading = true;
    this.processMessage = environment.appMessages.loadingMesage;

    this.apiService.groupId().pipe(
      switchMap(groupId =>{
        this.empId = groupId;
        return this.districtService.getDistricts(this.empId);
      })
    ).subscribe({
      next: (data: any) => {
        this.districtOptions = DataUtils.createUniqueSortedList(data?.Payload.DistrictData.map((district: any) => ({
          label: district.District.trim(),
          value: district.District
        })));

        this.typeOptions = DataUtils.createUniqueSortedList(data?.Payload.OrderTypeData.map((type: any) => ({
          label: type.Value.trim(),
          value: type.Value
        })));

        if (this.queryData) {
          this.queryData = undefined;
        }
      },
      error: error => {
        this.processMessage = '';
        this.isLoading = false;
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'OrdersByDistrictInSapComponent.LoadDistricts', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.processMessage = '';
        this.isLoading = false;
      }
    })
  }

  getSelectedDistrictDetails(): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.apiService.groupId().pipe(
      switchMap(groupId => {
        this.empId = groupId;
        const payload = {
          District: this.selectedDistrict === "" ? null : this.selectedDistrict,
          InSap: this.selectedInSap === "" ? null : this.selectedInSap,
          SchedDate: this.selectedScheduledDate === "" ? null : this.selectedScheduledDate,
          Type: this.selectedType === "" ? null : this.selectedType,
          userId: sessionStorage.getItem('userId'),
          PageNumber: this.currentPage,
          PageSize: this.pageSize,
          SortField: this.sortField,
          SortOrder: this.sortOrder,
          SearchText: this.searchText,
          groupId: groupId
        }
        return this.adminService.getAdminDistrictOrders(payload);
      })
    ).subscribe({
      next: (data: any) => {
        const totalRec = data?.Payload?.TotalRecords;
        this.isLoading = false;
        const updatedData = data?.Payload?.Data.map((item: any) => {
          return {
            ...item,
            SchedDate: this.datePipe.transform(new Date(item.SchedDate.trim()), "MM-dd-yyyy")?.toString()
          }
        });
        this.filteredData$ = of(updatedData);
        this.totalRecords = totalRec;
        if (data?.Payload?.Data?.length === 0) {
          const errMsg = environment.appMessages.noData
          this.messageService.add({ severity: 'warn', summary: 'No Data', detail: errMsg, life: environment.appSettings.snakbarLife });
        }
      },
      error: error => {
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Error occurred while retreiving existing admin district orders.', detail: errMsg });
        this.isLoading = false;
        this.processMessage = '';
        this.monotoringService.logException({ name: 'OrdersByDistrictInSapComponent.getSelectedDistrictDetails', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;
        this.processMessage = '';
      }
    });
  }

  onCellClicked(event: any[]) {
    this.isLoading = false;
    this.cellValue = event;
    this.selectedRow = event[1];
  }

  reload() {
    this.tblConfig.clear();
    this.LoadHeader();
  }

  onReloadClicked() {
    this.reload();
  }

  onDistrictChange(event: any) {
    this.selectedDistrict = event;
  }

  onInSapChange(event: any) {
    this.selectedInSap = event;
  }

  onScheduledDateChange(event: any) {
    this.selectedScheduledDate = event;
  }

  onTypeChange(event: any) {
    this.selectedType = event;
  }

  getSearchDisabledStatus() {
    return this.selectedDistrict === ""
  }

  onSearch(): void {
    this.currentPage = 1;
    this.tblConfig.resetPage();
    this.getSelectedDistrictDetails();
  }


  onClear(): void {

    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-question',
      acceptButtonStyleClass: 'custom-accept-button',
      rejectButtonStyleClass: 'custom-reject-button',
      accept: () => {

        this.selectedType = "";
        this.selectedInSap = "";
        this.selectedScheduledDate = "";
        this.selectedDistrict = "";
        this.sortField = "";
        this.sortOrder = 1;
        this.searchText = "";
        this.filteredData$ = of([]);
        this.totalRecords = 0
      },

    });


  }

  onPageChanged(event: any): void {

    const pageSize = event.pageSize;
    const pageNumber = event.page; // zero-based page index    
    this.currentPage = pageNumber;
    this.pageSize = pageSize;
    this.getSelectedDistrictDetails();
  }

  onSearchText(event: any): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.searchText = event.searchText;
    this.getSelectedDistrictDetails();
  }

  onSortClicked(event: any): void {
    this.sortField = event.sortField;
    this.sortOrder = event.sortOrder;
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.getSelectedDistrictDetails();
  }



}

